import { createContext, useContext } from 'react';
import { MobxReactForm } from 'mobx-react-form';

export const FundBuyerFormContext = createContext<MobxReactForm>(null);

export const useFundBuyerForm = () => useContext(FundBuyerFormContext);
